import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { TenantSettingService as Service } from '../tham-so-he-thong/TenantSettingService';
import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';

import { FormatDisplay } from '../../../shared/format';

const minuteNextStepOptions = [
  { value: 5, label: "5 phút" },
  { value: 10, label: "10 phút" },
  { value: 15, label: "15 phút" },
  { value: 20, label: "20 phút" },
  { value: 25, label: "25 phút" },
  { value: 30, label: "30 phút" },
  { value: 45, label: "45 phút" },
];

export const List = () => {
  const [tempAutoSign, setTempAutoSign] = useState(null);
  const [isSerialDisable,setIsSerialDisable] = useState(null)
  const [symbol, setSymbol] = useState([]);
  const header = 'cấu hình gửi email thông báo hóa đơn máy tính tiền cần ký';
  const dataKey = 'id';
  const [tempSerial,setTempSerial] = useState(null)

  const renderOptions = useCallback(() => {
    let newOptions;
    if (tempAutoSign) {
      newOptions = minuteNextStepOptions.filter((option) => option.value <= 30);
    
    } else {
    newOptions = minuteNextStepOptions.filter((option) => option.value >= 30 && option.value <= 60);
    
    }
    return newOptions;
  },[tempAutoSign]);

  const defaultValue = useMemo(()=>{
    return renderOptions()[0].value
  },[renderOptions])
  const timeRunOptions = [
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(11, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '18:00' },
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(12, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '19:00' },
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(13, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '20:00' },
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(14, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '21:00' },
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(15, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '22:00' },
    { value: FormatDisplay.date(new Date('2023-07-21').setHours(16, 0, 0, 0), 'YYYY-MM-DDTHH:mm:ss'), label: '23:00' },
  ];
  const {
    render: renderDataTable,
    refreshLazyData,
    reloadLazyData,
    selectedItems,
  } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'emailTo', header: 'Email nhận thông báo', matchMode: 'contains', minWidth: 160 },
      { field: 'timeRunView', header: 'Thời gian bắt đầu', minWidth: 160, dataType: 'time' },
      { field: 'minuteNextStep', header: 'Thời gian gửi lại thông báo/ký lại hóa đơn', width: 400 },
      { field: 'serial', header: 'Ký hiệu', matchMode: 'contains', minWidth: 120 },
      {
        field: 'autoSign',
        header: 'Chức năng',
        dataType:"fromFilterOptions",
        minWidth: 150,
        filterType: 'dropdown',
        matchMode: 'contains',
        filterOptions: [
          { value: true, label: "Ký tự động hoá đơn" },
          { value: false, label: "Gửi email thông báo" },
        ],
      },
      {
        field:'isUse',header:"Sử dụng", matchMode: 'equals', filterType: 'boolean', dataType: 'checkbox'
      }
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getListJob(params);
    },
  });
  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000, Sorting: 'creationTime', SortType: 'DESCEND' }).then(
      ({ items }) => {
        const _registerInvoices = [];
        items.forEach((item) => {
          item.label = item.symbolCode;
          if (item.symbolCode[4] === 'M') {
            _registerInvoices.push(item.symbolCode);
          }
        });
        setSymbol([{label:"- Tất cả -",value:null},..._registerInvoices.map(item=>{
          return {label:item,value:item}
        })]);
     
      }
    );
  }, []);
  const {
    render: renderDialogCrup,
    create,
    update,
    clone,
    getValue,
    setValue
  } = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {
        field: 'emailTo',
        header: 'Email nhận thông báo',
        required: true,
        InputTextProps: {
          maxLength: 250,
          placeholder: 'Các email được ngăn cách bằng dấu phẩu (,) hoặc chấm phẩy ( ; )',
          validator: 'multipleEmail',
        },
        className: 'md:col-12',
      },
     
      {
        field: 'autoSign',
        type: 'Dropdown',        
        className: 'md:col-6',
        header:'Loại nghiệp vụ',
        DropdownProps: { options: [{ value: false, label: "Gửi email thông báo" },{value:true,label:'Ký tự động hoá đơn'}] },
      },
      {
        field: 'serial',
        header: 'Ký hiệu',
        type: 'Dropdown',
        DropdownProps: { filter: true, options: symbol,disabled:isSerialDisable ? isSerialDisable :!tempAutoSign,placeholder:"- Tất cả -" },
        className: 'md:col-6',
      },
      {
        field: 'timeRun',
        header: 'Thời gian bắt đầu',
        required: true,
        type: 'Dropdown',
        DropdownProps: { options: timeRunOptions },
        className: 'md:col-6',
      },
      {
        field: 'minuteNextStep',
        header: tempAutoSign ? "Thời gian ký lại hoá đơn" : "Thời gian gửi lại thông báo",
        type: 'Dropdown',
        DropdownProps: {
          options: renderOptions(),
        },
        className: 'md:col-6',
      },
      {
        field:"isUse",
        type:'Checkbox',
        header:"Sử dụng",
        className:"md:col-6"
      },
      {
        field: "customText",
        type: "custom",
        body: (
          <div className="flex flex-column">
            <p className="font-italic font-bold text-lg">Điều kiện:</p>
            <p className="font-italic">1. Khách hàng đã đăng ký chứng thư số FILE hoặc Service trên phần mềm</p>
            <p className="font-italic">2. Hoá đơn có trạng thái Chờ ký và đã có ngày hoá đơn</p>
          </div>
        ),
      },
    ],
    defaultValue: {
      minuteNextStep: tempAutoSign ? 5 : 30,
      autoSign: false,
      isUse:true
    },
    createItem: (item) => {
      return Service.createJob({
        ...item,
      });
    },
    updateItem: (id, item) => {
      return Service.updateJob({
        ...item,
        id: id,
      });
    },
    refreshLazyData,
  });
useEffect(()=>{
  const values = getValue()
  setTempAutoSign(values.autoSign)
},[getValue])
useEffect(()=>{
  const data = getValue()
  if(!renderOptions().find(option=>option.value === data.minuteNextStep)){
  data.minuteNextStep = defaultValue
  setValue(data)
  }
  if(!tempAutoSign){
    if(data.serial){
    setTempSerial(data.serial)
    }
    data.serial = null
    setValue(data)
  }
  if(tempAutoSign && tempSerial){
    data.serial = tempSerial
    setValue(data)
  }
},[defaultValue,renderOptions,tempAutoSign,tempSerial]) // eslint-disable-line react-hooks/exhaustive-deps
  const { renderToolbar } = useToolbar({
    dataKey,
    create:()=>{
      setTempSerial(null)
      setIsSerialDisable(null)
      create()
    },
    update:(item)=>{
      setIsSerialDisable(true)
      update(item)
    },
    clone,
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.deleteJob(id);
    },
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  );
};
